import {DrawerProps} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {Meter} from "../types.ts";
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: Meter,
        // Resolves true when the record was saved. The drawer closes ONLY then: a server
        // error, or a cancelled Retire confirm, leaves it open with the operator's values.
        handleSubmit: (values: Meter) => Promise<boolean>
    }) => {

    const title = record?.id ? I18n.get('Edit Meter') : I18n.get('Add Meter');

    const handleFormSubmit = async (values: Meter) => {
        const saved = await handleSubmit(values);
        if (saved) {
            onClose();
        }
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    )
};
